import React, { useState } from "react";
import { Button, Toggle } from "components/common";
import { useMutation } from "@apollo/react-hooks";
import { REFUND_USER } from "../../../utils/mutations";

const RefundModal = ({ closeModal, user, creditUsed, refetch }) => {
  const [success, setSuccess] = useState(false);
  const [amount, setAmount] = useState(-creditUsed || 0);
  const [paymentMethodId, setPaymentMethodId] = useState(null);
  const [error, setError] = useState("");
  const [refundUser, { loading: refundLoading }] = useMutation(REFUND_USER);

  const processRefund = () => {
    if (refundLoading) return;
    if (!amount || amount < 0) return;
    setError("");
    refundUser({
      variables: {
        email: user.email,
        amount,
        paymentMethodId
      }
    }).then(async res => {
      const { status, message } = res.data.refundUser;
      if (status !== "SUCCESS") {
        setError(message);
      } else {
        refetch();
        setSuccess(true);
        // closeModal();
      }
    });
  };

  const paymentMethodOptions = [
    <option selected value={null}>
      Default
    </option>,
    ...user.payment_methods.map(pm => (
      <option value={pm.id}>
        {`${pm.institution} ${pm.nickname} - ${pm.account_number_last_four}`}
      </option>
    ))
  ];

  return success ? (
    <div style={{ backgroundColor: "#c4c4c4" }} className="py-8 px-12">
      <div className="text-2xl">
        You have successfully processed the refund.
      </div>
    </div>
  ) : (
    <div style={{ backgroundColor: "#FAFAFA" }} className="py-8 px-12">
      <div>
        <label>
          Amount:
          <input
            type="number"
            className="mb-5 w-3/4 p-2"
            defaultValue={amount}
            onChange={e => setAmount(Number(e.target.value))}
          />
        </label>
      </div>
      <div className="mb-5 w-3/4 p-2">
        <label>
          Payment Method
          <select onChange={e => setPaymentMethodId(Number(e.target.value))}>
            {paymentMethodOptions}
          </select>
        </label>
      </div>

      <div className={error ? "text-red-600 mb-4" : "hidden"}>{error}</div>

      <Button
        className={`mb-6 w-full ${refundLoading ? "opacity-50" : ""}`}
        disabled={refundLoading}
        onClick={processRefund}
      >
        Submit
      </Button>
    </div>
  );
};

export default RefundModal;
